"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFieldMapperFactory = exports.noOp = void 0;

var _FieldMapper = require("../Mappers/FieldMapper");

var _StringFieldMapper = require("../Mappers/StringFieldMapper");

var _DateTimeFieldMapper = require("../Mappers/DateTimeFieldMapper");

var _DateTimeRangeFieldMapper = require("../Mappers/DateTimeRangeFieldMapper");

var _NumberFieldMapper = require("../Mappers/NumberFieldMapper");

var _NumberRangeFieldMapper = require("../Mappers/NumberRangeFieldMapper");

var _MultiFieldMapper = require("../Mappers/MultiFieldMapper");

var _GeolocationFieldMapper = require("../Mappers/GeolocationFieldMapper");

var _linkFieldMapper = require("../Mappers/linkFieldMapper");

var _BooleanFieldMapper = require("../Mappers/BooleanFieldMapper");

var noOp = function noOp() {
  return null;
};
/**
 *
 * @param {Object} field The required properties `field.properties.fieldType`
 */


exports.noOp = noOp;

var defaultFieldMapperFactory = function defaultFieldMapperFactory(field) {
  var mapper;

  switch (field.properties.fieldType) {
    case "DateTime":
    case "Time":
      mapper = _DateTimeFieldMapper.mapDateTimeFieldProperties;
      break;

    case "DateTimeRange":
      mapper = _DateTimeRangeFieldMapper.mapDateTimeRangeFieldProperties;
      break;

    case "Geolocation":
      mapper = _GeolocationFieldMapper.mapGeolocationProperties;
      break;

    case "Multi":
      mapper = _MultiFieldMapper.mapMultiProperties;
      break;

    case "Number":
      mapper = _NumberFieldMapper.mapNumberFieldProperties;
      break;

    case "NumberRange":
      mapper = _NumberRangeFieldMapper.mapNumberRangeFieldProperties;
      break;

    case "String":
      mapper = _StringFieldMapper.mapStringFieldProperties;
      break;

    case "Link":
      mapper = _linkFieldMapper.mapLinkFieldProperties;
      break;

    case "Common":
      mapper = _FieldMapper.mapCommonFieldPropertiesFromObject;
      break;

    case "Boolean":
      mapper = _BooleanFieldMapper.mapBooleanFieldProperties;
      break;

    default:
      mapper = noOp;
  }

  return mapper;
};

exports.defaultFieldMapperFactory = defaultFieldMapperFactory;